import { L, vocabulary } from '../define.js';
export const SERVICE_CENTER_VOCABULARIES = [
    vocabulary('conversation.consent_purpose', '@vello/service-center CONSENT_PURPOSES', {
        messaging: L('Troca de mensagens', 'Messaging', 'Intercambio de mensajes', 'Scambio di messaggi'),
        recording: L('Gravação', 'Recording', 'Grabación', 'Registrazione'),
        processing: L('Tratamento dos dados', 'Data processing', 'Tratamiento de datos', 'Trattamento dei dati'),
        ai_processing: L('Tratamento por inteligência artificial', 'AI processing', 'Tratamiento por inteligencia artificial', 'Trattamento tramite intelligenza artificiale'),
    }),
    vocabulary('conversation.participant_role', '@vello/service-center PARTICIPANT_ROLES', {
        rider: L('Passageiro', 'Rider', 'Pasajero', 'Passeggero'),
        driver: L('Motorista', 'Driver', 'Conductor', 'Autista'),
        courier: L('Entregador', 'Courier', 'Repartidor', 'Corriere'),
        candidate: L('Candidato', 'Candidate', 'Candidato', 'Candidato'),
        business: L('Empresa', 'Business', 'Empresa', 'Azienda'),
        merchant: L('Lojista', 'Merchant', 'Comercio', 'Esercente'),
        agent: L('Atendente', 'Agent', 'Agente', 'Operatore'),
        bot: L('Assistente automático', 'Automated assistant', 'Asistente automático', 'Assistente automatico'),
        system: L('Sistema', 'System', 'Sistema', 'Sistema'),
    }),
    vocabulary('service_center.case_domain', '@vello/service-center CASE_DOMAINS', {
        support: L('Suporte', 'Support', 'Soporte', 'Assistenza'),
        finance: L('Financeiro', 'Finance', 'Finanzas', 'Finanza'),
        safety: L('Segurança', 'Safety', 'Seguridad', 'Sicurezza'),
        risk: L('Risco', 'Risk', 'Riesgo', 'Rischio'),
    }),
    vocabulary('conversation.channel', '@vello/omnichannel-gateway GATEWAY_CHANNELS; @vello/service-center CHANNELS', {
        web_widget: L('Widget do site', 'Website widget', 'Widget del sitio', 'Widget del sito'),
        mobile_app: L('Aplicativo', 'App', 'Aplicación', 'App'),
        whatsapp_message: L('Mensagem de WhatsApp', 'WhatsApp message', 'Mensaje de WhatsApp', 'Messaggio WhatsApp'),
        whatsapp_call: L('Ligação de WhatsApp', 'WhatsApp call', 'Llamada de WhatsApp', 'Chiamata WhatsApp'),
        email: L('E-mail', 'Email', 'Correo electrónico', 'E-mail'),
        sms: L('SMS', 'SMS', 'SMS', 'SMS'),
        voice: L('Ligação de voz', 'Voice call', 'Llamada de voz', 'Chiamata vocale'),
        whatsapp: L('WhatsApp', 'WhatsApp', 'WhatsApp', 'WhatsApp'),
    }),
    // D625: the priority the server bounded from what the served party picked (a lost item is high).
    vocabulary('conversation.priority', '@vello/service-center CONVERSATION_PRIORITIES', {
        low: L('Baixa', 'Low', 'Baja', 'Bassa'),
        normal: L('Normal', 'Normal', 'Normal', 'Normale'),
        high: L('Alta', 'High', 'Alta', 'Alta'),
        urgent: L('Urgente', 'Urgent', 'Urgente', 'Urgente'),
    }),
];
//# sourceMappingURL=service-center.js.map